const features = [
  {
    title: '科幻巨制：未来已来',
    desc: '从《沙丘》到《阿凡达》，科幻电影以震撼视效和深刻哲思重新定义观影体验。本专题收录近十年最具影响力的科幻大片，带你在免费电影在线观看中领略浩瀚宇宙。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20neon%20accents%20and%20dark%20space%20background%2C%20geometric%20abstract%20shapes%2C%20warm%20coral%20and%20amber%20light%20streaks%2C%20modern%20film%20aesthetic%2C%20professional%20movie%20poster%20style%20composition&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '科幻',
    stat: '156部',
  },
  {
    title: '国产影视崛起之路',
    desc: '从《流浪地球》到《漫长的季节》，国产影视工业化进程加速。本专题梳理近年来口碑与票房双丰收的华语佳作，见证中国影视力量。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20artistic%20composition%20with%20traditional%20and%20modern%20elements%2C%20warm%20golden%20and%20red%20tones%2C%20dramatic%20lighting%2C%20film%20production%20aesthetic%2C%20elegant%20movie%20poster%20style%20with%20dark%20background%20and%20coral%20highlights&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '华语',
    stat: '502部',
  },
  {
    title: '悬疑犯罪：真相只有一个',
    desc: '从《看不见的客人》到《寄生虫》，悬疑类型持续刷新叙事边界。聚焦社会议题与人性幽微，每一帧都是精心设计的谜题。',
    img: 'https://readdy.ai/api/search-image?query=Crime%20mystery%20atmosphere%20with%20dramatic%20shadows%20and%20warm%20accent%20lighting%2C%20detective%20film%20noir%20aesthetic%2C%20dark%20background%20with%20amber%20highlights%2C%20cinematic%20suspense%20composition%2C%20elegant%20movie%20visual%20style&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '悬疑',
    stat: '257部',
  },
  {
    title: '动画电影的成人世界',
    desc: '动画不止是童年回忆。从宫崎骏到新海诚，从皮克斯到中国水墨，动画电影以独特艺术语言探讨成长、爱与失去。',
    img: 'https://readdy.ai/api/search-image?query=Animated%20film%20artistic%20composition%20with%20soft%20warm%20colors%2C%20hand-drawn%20style%20elements%20blending%20with%20modern%20digital%20aesthetic%2C%20dreamy%20atmosphere%20with%20golden%20and%20coral%20tones%2C%20cinematic%20animation%20poster%20style&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '动画',
    stat: '643部',
  },
  {
    title: '纪录片：真实的力量',
    desc: '从自然奇观到社会观察，纪录片以真实镜头捕捉世界。本专题精选 IMDb 高分纪录佳作，用真实故事触动心灵。',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20aesthetic%20with%20natural%20landscape%20elements%2C%20warm%20earthy%20tones%2C%20cinematic%20real-life%20photography%20style%2C%20soft%20dramatic%20lighting%2C%20professional%20composition%20with%20amber%20and%20coral%20accents%2C%20dark%20subtle%20background&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '纪录',
    stat: '189部',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-4 whitespace-nowrap">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            深度影视专题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            每一期聚焦一个主题，横跨类型、导演、年代，深度解析影视文化
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-heading text-base font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap ml-2">
                    {item.stat}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}